<template>
  <v-container
    fluid
    class="d-flex flex-column"
    style="min-height: 590px"
  >
    <div class="pt-0 mt-0 flex-grow-1 ma-32 h-100 d-flex flex-column">
      <div class="flex-grow-1" />
      <div class="py-16">
        <p class="text-h1 text-center brand--text mt-auto">
          {{ $t('label.hello') }}
        </p>
        <p
          class="fade-in second text-center font-weight-normal pt-4 text-h5 brand--text"
        >
          {{ $t('label.welcome_to_guestplan') }}
        </p>
      </div>
      <div class="flex-grow-1" />
    </div>
    <p
      class="fade-in third text-center font-weight-normal px-8 text-subtitle-1"
    >
      {{ $t('message.onboarding_welcome_message') }}
    </p>
  </v-container>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'WelcomeStepWelcome',
  components: { },
  props: { },
  data() {
    return { };
  },
  computed: { },
  methods: {
    // eslint-disable-next-line vue/no-unused-properties
    submit() {
      this.$emit('advance');
    },
  },
});
</script>

<style>

.fade-in {
  opacity: 0;
  animation: fadeIn 0.6s forwards;
}

.fade-in.first{ animation-delay: 0s; }
.fade-in.second { animation-delay: 0.6s; }
.fade-in.third { animation-delay: 1.4s; }

@keyframes fadeIn {
  0% {
    opacity: 0;
    transform: translateY(20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

</style>
